import { RouterProvider } from "react-router-dom";
import "./App.css";
import router from "./routes";
import { I18nProvider } from "./i18n-context";
import { ToastProvider } from "./components/ToastContext";

function App() {
  return (
    <I18nProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </I18nProvider>
  );
}

export default App;
